import ILabelAttributes from '@app/types/data/base/ILabelAttributes';

export type RelativeDOMRect = Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left' | 'width' | 'height'>;

export const getPinAttributes = (svgPin: Element, relatedSvgPath?: Element | null): ILabelAttributes => {
	const elementId: string | null = svgPin.getAttribute('id');
	const attributesConfig: Record<string, string> = {};

	if (elementId) {
		elementId
			// split in key-value strings
			.split('_')
			// split key-value pairs, lowercase values to reduce error-proneness
			.map((keyValuePair: string): string[] => keyValuePair.toLowerCase().split(':'))
			// zip pairs into attributes config
			.forEach((keyValuePair: string[]): void => {
				attributesConfig[keyValuePair[0]] = keyValuePair[1] || '';
			});
	}

	// apply config, fallback to defaults
	const attributes: ILabelAttributes = {
		alignmentX: attributesConfig.align ? (attributesConfig.align.charAt(1) as 'c' | 'r' | 'l') : 'c',
		alignmentY: attributesConfig.align ? (attributesConfig.align.charAt(0) as 'c' | 't' | 'b') : 't',
		imageAlignment: attributesConfig.imagepos ? (attributesConfig.imagepos as 't' | 'b') : undefined,
		fontStyle: attributesConfig.fontstyle ? (attributesConfig.fontstyle as 'S' | 'L' | 'lake') : 'S',
		fontColor: attributesConfig.fontcolor === 'dark' ? 'dark' : 'light',
		showAddOn: attributesConfig.addon === '1',
		showLabel: attributesConfig.showlabel === '1',
		hideInViewports: attributesConfig.hide ? (attributesConfig.hide.split(',') as ['s' | 'm' | 'l']) : undefined
	};

	if (relatedSvgPath) {
		attributes.relatedSvgPathColor = relatedSvgPath.getAttribute('stroke') || undefined;
	}

	return attributes;
};

/**
 * Calculates the coordinates of the child relative to its parent.
 * Note: using getBoundingClientRect() takes CSS transforms into calculations.
 * @param parent
 * @param child
 */
export const getRelativeBoundsTo = (child: Element, parent: Element): RelativeDOMRect => {
	const parentPos: DOMRect = parent.getBoundingClientRect();
	const childPos: DOMRect = child.getBoundingClientRect();

	return {
		top: childPos.top - parentPos.top,
		right: childPos.right - parentPos.right,
		bottom: childPos.bottom - parentPos.bottom,
		left: childPos.left - parentPos.left,
		width: childPos.width,
		height: childPos.height
	};
};
